const ALGOACADEMY_HOST_PATTERN = /^([a-z0-9-]+\.)?algoacademy\.pl$/i
const DEFAULT_REDIRECT = '/app'

export type ResolvedRedirect = { url: string; external: false } | { url: string; external: true }

export function resolveRedirect(raw: string | null | undefined): ResolvedRedirect {
  if (!raw) return { url: DEFAULT_REDIRECT, external: false }

  if (raw.startsWith('/') && !raw.startsWith('//')) {
    return { url: raw, external: false }
  }

  let parsed: URL
  try {
    parsed = new URL(raw)
  } catch {
    return { url: DEFAULT_REDIRECT, external: false }
  }

  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') {
    return { url: DEFAULT_REDIRECT, external: false }
  }

  const allowLocalhost =
    process.env.NODE_ENV !== 'production' &&
    (parsed.hostname === 'localhost' || parsed.hostname === '127.0.0.1')

  if (!allowLocalhost && !ALGOACADEMY_HOST_PATTERN.test(parsed.hostname)) {
    return { url: DEFAULT_REDIRECT, external: false }
  }

  return { url: parsed.toString(), external: true }
}
